/**
 * Google AdSense Configuration
 * 
 * Replace these values with your actual AdSense IDs:
 * 1. Get Publisher ID from AdSense Dashboard
 * 2. Create ad units and get their IDs
 * 3. Update the values below
 */

export const AD_CONFIG = {
    // Keep ad slots disabled while the site is under AdSense review.
    // Set REACT_APP_ADSENSE_ADS_ENABLED=true after approval to serve placements.
    adsEnabled: process.env.REACT_APP_ADSENSE_ADS_ENABLED === 'true',

    // Your AdSense Publisher ID (format: ca-pub-XXXXXXXXXXXXXXXX)
    publisherId: 'ca-pub-9774215915763759',
    
    // Ad Unit IDs (get from AdSense Dashboard → Ads → By ad unit)
    adUnits: {
        // Article page ads
        articleHeader: '1302343534',      // Horizontal banner after article header
        articleInline: '3651081370',     // Rectangle ad between sections
        
        // Home page ads
        homePage: '4698663067',           // Horizontal banner after cards
        
        // Album/Collection page ads
        albumPageTop: '4698663067',       // Horizontal banner after search bar (reuse homePage for now)
        albumPageMiddle: '7676180192',    // Rectangle ad in middle of grid (reuse sidebar for now)
        albumPageBottom: '4698663067',    // Horizontal banner before pagination (reuse homePage for now)
        
        // Sidebar ads (if you add a sidebar)
        sidebar: '7676180192',            // Vertical ad for sidebar
    }
};
